module.exports = __webpack_public_path__ + "img/nbus_container_3_left_mo.28ded61a.jpg";